<div id="infrastructure">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">]
                    <h4 class="card-title">Conference Room</h4>
                        <p class="inner-lead">The conference room is well equipped with public address system; facilitate course delivery through use of audio-visual inputs from slide presentation to video clips and video lessons. It has a seating capacity of about 100 people for conducting seminars, workshops, conferences and guest lectures.</p>
                    </div>
                </div>
            </div>
        </div>